import { useRouter } from 'next/router'

import { AppLanguage } from '~/types/locale'

export default function useCleanBasePathFromAsPath(): string {
  // We are using this to ensure that asPath doesn't contain the basePath.
  // See https://github.com/vercel/next.js/issues/35578 for the reported next.js issue
  return useRouter()
    .asPath.split('/')
    .filter((part, index) => index !== 1 || !(Object.values(AppLanguage) as string[]).includes(part))
    .join('/')
}
